export const OfficialNumbers = {
    USERS: 2500000,
    CITIES: 51,
    DEALS: 12000,
    PARTNERS: 6000,
    GUESTS_PER_MONTH: 300000,

    /*
     * Store ratings (DE storefront), last checked 2026-08-25. Update from
     * https://itunes.apple.com/lookup?id=1484512399&country=de and the
     * aggregateRating JSON-LD on the Play Store listing.
     */
    APP_STORE_RATING: 4.8,
    APP_STORE_RATING_COUNT: 21000,
    PLAY_STORE_RATING: 4.2,
    PLAY_STORE_RATING_COUNT: 6300,
}
